interface MenuItem {
  id: number;
  page: string;
  title: string;
  link: string;
  has_dropdown: boolean;
  sub_menus?: {
    link: string;
    title: string;
  }[];
}
[];

const menu_data: MenuItem[] = [
  {
    id: 1,
    page: "nav_1",
    has_dropdown: false,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    page: "nav_1",
    has_dropdown: true,
    title: "Ecosystem",
    link: "/#feature",
    sub_menus: [
      { link: "https://dashboard.invtron.com", title: "Governance Dashboard" },
      { link: "https://tokenomics.invtron.com", title: "Interactive Tokenomics" },
      { link: "https://simulation.invtron.com", title: "Ecosystem Simulation" },
    ],
  },
  {
    id: 3,
    page: "nav_1",
    has_dropdown: true,
    title: "About",
    link: "/#team",
    sub_menus: [
      { link: "/#VisionArea", title: "Vision" },
      { link: "/#roadmap", title: "Roadmap" },
      { link: "/#team", title: "Team Members" },
    ],
  },
  {
    id: 4,
    page: "nav_1",
    has_dropdown: false,
    title: "Contact",
    link: "/contact",
  },
  {
    id: 5,
    page: "nav_1",
    has_dropdown: false,
    title: "Whitepaper",
    link: "/flipbook/whitepaper",
  },
  {
    id: 6,
    page: "nav_1",
    has_dropdown: false,
    title: "Litepaper",
    link: "/flipbook/litepaper",
  },
  {
    id: 7,
    page: "nav_1",
    has_dropdown: false,
    title: "Join Telegram",
    link: "https://t.me/Invtrondaogroup",
  },

  {
    id: 1,
    page: "nav_2",
    has_dropdown: true,
    title: "Home",
    link: "#",
    sub_menus: [{ link: "/", title: "Token Access" }],
  },
  {
    id: 2,
    page: "nav_2",
    has_dropdown: false,
    title: "Why Blockchain",
    link: "/home/#blockchain",
  },
  {
    id: 3,
    page: "nav_2",
    has_dropdown: false,
    title: "Feature",
    link: "/home/#feature",
  },
  {
    id: 4,
    page: "nav_2",
    has_dropdown: false,
    title: "Contact",
    link: "/contact",
  },
];
export default menu_data;
